module.exports = __webpack_public_path__ + "static/img/service.2300718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/service.png
// module id = XNwe
// module chunks = 1